import React, { ReactNode } from 'react';
import Banner from './Banner';
import LogoBanner from './LogoBanner';

import Navbar from './Navbar';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';

import { Inter } from 'next/font/google';
const inter = Inter({ subsets: ['latin'] });

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className={`flex flex-col min-h-screen ${inter.className}`}  >
      <div className="fixed top-0 left-0 right-0 z-50 flex flex-col"> 
          <Banner />
        <LogoBanner/> 
        <Navbar />
      </div>
      
      <main className="flex-grow pt-[150px]">
        {children}
      </main>
        <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Layout;

